<template>
  <div class="modal" v-if="seen">
    <div class="renamefile">
      <div class="rename-header d-flex flex-row justify-content-between align-items-center">
        <h3>Get Shareable Link</h3>
        <span @click="closebox" class="rename-closefile">
          <img src="@/assets/search-icons/Close.svg" />
        </span>
      </div>
      <div class="inputbox">
        <h4>Access Right</h4>
        <div class="right">
          <span><input type="radio" v-model="right" checked value="view"> <span>View</span></span>
          <span><input type="radio" v-model="right" value="edit"> <span>Edit</span></span>
        </div>
      </div>
      <div class="rename-save d-flex justify-content-start">
        <span @click="save">Copy link</span>
      </div>
    </div>
  </div>
</template>
<style>
.right {
  display: inline-flex;
}

.right>span:first-child {
  margin-right: 10px;
}

.right>span span {
  font-size: 14px;
}

.modal div.renamefile div input {
  width: auto;
  margin-right: 5px;
}

h4 {
  font-size: 15px;
  font-weight: 700;
  text-align: left;
}

.modal div.renamefile div {
  margin-top: 0 !important;
  width: 100%;
}

.modal div.renamefile {
  padding: 24px !important;
}

.renamefile input {
  background: transparent !important;
  box-shadow: none !important;
  border: 1px solid #A7B9CB !important;
  padding: 8px 6px;
}

.rename-closefile {
  background: #F2F7FC;
  border-radius: 50%;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.modal div.renamefile .rename-save {
  margin-top: 16px !important;
}

.modal div.renamefile .inputbox {
  margin-top: 16px !important;
}

.rename-save span {
  background: #3F96D1;
  color: #fff;
  border-radius: 6px;
  height: 44px;
  width: 150px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}
</style>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'

export default {
  data() {
    return {
      seen: false,
      id: null,
      right: 'view',
      sharelink: null
    }
  },
  methods: {
    ...mapMutations([
      'EMPTY_FILE_ACTION'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    load(sharelink, id) {
      this.seen = true
      this.sharelink = sharelink
      this.id = id
    },
    save() {
      this.seen = false
      let link = this.sharelink;
      let a = document.createElement("input");

      a.setAttribute("value", link);
      a.setAttribute("id", "link");
      a.click();
      a.style.position = "absolute";
      a.style.left = "-9999px";
      document.body.appendChild(a);
      let l = document.getElementById("link");
      l.select();
      document.execCommand("copy");
      document.body.removeChild(a);

      let data = {
        token: cookies.getCookie("token"),
        id: this.id,
        right: this.right,
        link,
      };

      let that = this;

      this.$socket.emit("save-link", data, function (data) {
        if (data.data === true) {
          that.$toast.open({
            message:
              '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> Link copied to clipboard',
            type: "default",
            position: "bottom-right",
          });
        }

        if (data.data === false) {
          that.logincall();
          that.$router.push('/login')
        }
      });
    },
    closebox() {
      this.seen = false
      this.right = 'view'
    }
  }
}
</script>
